import { z } from 'zod';

export const AddressScalarFieldEnumSchema = z.enum(['addressId','cityId','caseId','addressType','firstName','lastName','streetNum','street','apartment','address2','city','state','zip','phone','altPhone','email','note','alert','company','streetOrig','vehicleId','externalId','rowTimestamp']);

export default AddressScalarFieldEnumSchema;
